import React from "react";

function Logo() {
  return (
    <div>
      <a className="navbar-brand col-2 logo" href="/">
        VU SWH
      </a>
    </div>
  );
}

export default Logo;
